import React from 'react';
import { FaRegFileExcel } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MDButton } from '../../MDButton';

type DownloadAsExcelProps = {
  data?: { [key: string]: string }[];
  generateData?: () => { [key: string]: string | number }[];
  fileName: string;
  as?: 'button' | 'icon' | 'both';
};

export function DownloadAsExcel({
  data,
  fileName,
  generateData,
  as = 'icon',
}: DownloadAsExcelProps) {
  const handleDownload = () => {
    const exportData = data || generateData?.();
    if (!exportData) return;

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, fileName);
  };

  if (as === 'icon') {
    return (
      <FaRegFileExcel
        fontSize={25}
        style={{ cursor: 'pointer' }}
        onClick={handleDownload}
        title="Download Excel"
      />
    );
  }

  if (as === 'button') {
    return (
      <MDButton onClick={handleDownload} variant="gradient" color="info">
        Download Excel
      </MDButton>
    );
  }

  return (
    <MDButton
      onClick={handleDownload}
      variant="gradient"
      color="info"
      startIcon={<FaRegFileExcel />}
    >
      Download Excel
    </MDButton>
  );
}
